import React from "react";
import { useSearchParams} from "react-router-dom";
const Index = ({ banner,etailCall }) => {
  const baseURL = process.env.REACT_APP_ASSETS_URL;
  // eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams();
  var srcSet = "";
  banner?.imgSrcSet.forEach((src, index) => {
    srcSet = srcSet + (baseURL + "" + src);
    if (index < banner.imgSrcSet.length - 1) {
      srcSet = srcSet + ",";
    }
  });
  const switchTabs = (tbId) => { 
    if(tbId){etailCall('Promo_banner_click',banner?.title)
    const URL = tbId;
    tbId = tbId.substring(1);
    try {
      tbId = atob(tbId);
      setSearchParams({ tab_id: tbId })
     // window.location.reload();
    } catch (error) {
      if(URL.search('www')){window.open(URL, "_blank")}
      else{
        setSearchParams({ tab_id: URL })
       // window.location.reload();
      }// window.open(URL); for other store
    }}
  };
 const bannerRedirection =(url)=>{
 
   if(url){
    etailCall('Promo_banner_click',banner?.title)
    window.open(url, "_blank");
   }
    return;
  }
  return banner ? (
    <div
      className={"thumbOverlay" + (banner?.url ? "" : " noCursor")}
      //banner?.url ? window.open(banner?.url, "_blank") : {}; 
      onClick={() =>{switchTabs(banner?.imgRedirectUrl);bannerRedirection( banner?.url); }}
    >
      <img
        srcSet={srcSet}
        sizes="(max-width: 767px) 50vw,(max-width: 1500px) 100vw,1500px"
        src={baseURL + banner?.imgSrc}
        alt={banner?.title}
        className="img-responsive"
        title={banner?.title}
        loading="lazy"
      />
    </div>
  ) : (
    <></>
  );
};

export default Index;
